var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-upload-image", class: _vm.rootClass },
    [
      _c(
        "div",
        {
          staticClass: "admin-upload-image__drop",
          class: {
            "admin-upload-image__drop--drag": _vm.dragOver,
            "admin-upload-image__drop--filled": !!_vm.displaySrc,
            "admin-upload-image__drop--pending": !!_vm.source,
          },
          attrs: { role: "button", tabindex: "0" },
          on: {
            click: _vm.openFileDialog,
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
                return _vm.openFileDialog.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                )
                  return null
                $event.preventDefault()
                return _vm.openFileDialog.apply(null, arguments)
              },
            ],
            dragover: function ($event) {
              $event.preventDefault()
              _vm.dragOver = true
            },
            dragleave: function ($event) {
              $event.preventDefault()
              return _vm.onDragLeave.apply(null, arguments)
            },
            drop: function ($event) {
              $event.preventDefault()
              return _vm.onFileDrop.apply(null, arguments)
            },
          },
        },
        [
          _c("input", {
            ref: "fileInput",
            staticClass: "admin-upload-image__native-input",
            attrs: {
              id: _vm.id,
              type: "file",
              accept: ".jpg,.jpeg,.png,.gif,image/jpeg,image/png,image/gif",
            },
            on: { change: _vm.onFileChange },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "admin-upload-image__preview" }, [
            _vm.displaySrc && !_vm.previewError
              ? _c("img", {
                  staticClass: "admin-upload-image__img",
                  attrs: { src: _vm.displaySrc, alt: "" },
                  on: {
                    error: function ($event) {
                      _vm.previewError = true
                    },
                  },
                })
              : _vm.displaySrc && _vm.previewError
              ? _c(
                  "div",
                  {
                    staticClass:
                      "admin-upload-image__empty admin-upload-image__empty--error",
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "admin-upload-image__empty-ring" },
                      [
                        _c("admin-icon", {
                          attrs: { name: "image", "aria-hidden": "true" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "admin-upload-image__empty-title" },
                      [_vm._v(_vm._s(_vm.trans("general.image_load_failed")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "admin-upload-image__empty-hint" },
                      [_vm._v(_vm._s(_vm.trans("general.choose_image")))]
                    ),
                  ]
                )
              : _c("div", { staticClass: "admin-upload-image__empty" }, [
                  _c(
                    "span",
                    { staticClass: "admin-upload-image__empty-ring" },
                    [
                      _c("admin-icon", {
                        attrs: { name: "upload", "aria-hidden": "true" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "admin-upload-image__empty-title" },
                    [_vm._v(_vm._s(_vm.trans("general.choose_image")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "admin-upload-image__empty-hint admin-upload-image__empty-hint--muted",
                    },
                    [_vm._v(_vm._s(_vm.trans("general.drop_or_click")))]
                  ),
                ]),
          ]),
          _vm._v(" "),
          _vm.displaySrc && !_vm.source && !_vm.previewError
            ? _c(
                "div",
                {
                  staticClass: "admin-upload-image__overlay",
                  attrs: { "aria-hidden": "true" },
                },
                [
                  _c(
                    "span",
                    { staticClass: "admin-upload-image__overlay-inner" },
                    [
                      _c("admin-icon", {
                        attrs: { name: "camera", "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.trans("general.update")))]),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.defaultImage && !_vm.source
        ? _c("div", { staticClass: "admin-upload-image__actions" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "confirm",
                    rawName: "v-confirm",
                    value: { ok: _vm.confirmRemove() },
                    expression: "{ ok: confirmRemove() }",
                  },
                ],
                staticClass: "btn btn-sm admin-upload-image__btn-remove",
                attrs: { type: "button" },
              },
              [
                _c("admin-icon", {
                  attrs: { name: "trash", "aria-hidden": "true" },
                }),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.trans("general.remove")) +
                    "\n        "
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.source
        ? _c("div", { staticClass: "admin-upload-image__pending" }, [
            _c("div", { staticClass: "admin-upload-image__pending-actions" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.uploadImage.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.trans("general.upload")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm admin-upload-image__btn-ghost",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.cancelUploadImage.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.trans("general.cancel_upload")) +
                      "\n            "
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }